interface ImageIconProps extends React.SVGProps<SVGSVGElement> {
    size?: number
    className?: string
}

const ImageIcon = ({ size = 24, className, ...props }: ImageIconProps) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0111 8.93896C11.0111 10.0441 10.1162 10.939 9.01111 10.939C7.9071 10.939 7.01111 10.0441 7.01111 8.93896C7.01111 7.83387 7.9071 6.93896 9.01111 6.93896C10.1151 6.94005 11.01 7.83496 11.0111 8.93896Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20 15.5C19.2598 14.8474 17.3363 13 15.7885 13C14.2399 13 13.3473 15.9077 11.858 15.9077C10.3688 15.9077 9.01584 14.5929 7.82251 15.4358C6.62917 16.2779 5 19 5 19"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="3.75"
            y="3.75"
            width="16.5"
            height="16.5"
            rx="2.25"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default ImageIcon
